export default __webpack_public_path__ + "static/media/oval-blur.079df2df.svg";